import { useRef, useState } from "react";

const useActionState = ({ onSuccess, onError } = {}) => {
    const [loading, setLoading] = useState(false);
    const onSuccessRef = useRef(onSuccess);
    const onErrorRef = useRef(onError);
    onSuccessRef.current = onSuccess;
    onErrorRef.current = onError;

    const run = async (action) => {
        setLoading(true);
        try {
            await action();
            await onSuccessRef.current?.();
            return true;
        } catch (err) {
            onErrorRef.current?.(err);
            return false;
        } finally {
            setLoading(false);
        }
    };

    return { run, loading };
};

export default useActionState;
